import dynamic from "next/dynamic";

const ColorPicker = dynamic(() => import("./color-picker-component"), {
  ssr: false,
});

export default ColorPicker;
